

















































































































































































































import { getSalaryOrderListApi, getSalaryOrderListData } from "@/api/salary";
import { mixin } from "@/mixin/tabPageInfoMixin";
import { dateFormat } from "@/utils/timeFormat";
import eventBus from "@/utils/bus";
import createSettlementDialog from "./createSettlementDialog.vue";
import payslipDialog from "./payslipDialog.vue";
import { Vue, Component, Mixins } from "vue-property-decorator";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "salaryTabStore",
  components: {
    createSettlementDialog,
    payslipDialog,
    commonDateRangeSelector,
  },
})
export default class extends Mixins(mixin) {
  searchInfo = {
    name: "",
    payment_date: [],
    status: -1,
    task_status: [],
    sort_field: "create_time",
    sort_type: "desc",
    month_date: [],
  };
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  tatistics: any = {};
  pickerOptions = {
    disabledDate(time: any) {
      const year = new Date().getFullYear(); //获取当前年份
      const month = new Date().getMonth() + 1; //获取当前月份
      const tot = new Date(year + "-" + month + "-1").getTime(); //获取当前年月转成时间戳
      // console.log(year, month, new Date(tot).getTime());
      return time.getTime() > tot;
    },
  };
  created() {
    this.mixinGetPageInfo("salaryTabStore");
    this.$nextTick(() => {
      const table: any = this.$refs.mainTable;
      table.sort(
        this.searchInfo.sort_field,
        this.searchInfo.sort_type
          ? this.searchInfo.sort_type === "asc"
            ? "ascending"
            : "descending"
          : "descending"
      );
    });
    eventBus.$on("quickly-create-salary-settlement", () => {
      this.handleSearch();
    });
  }
  beforeDestroy() {
    eventBus.$off("quickly-create-salary-settlement");
  }
  getList(params: { page: number; page_size: number }) {
    const option: getSalaryOrderListData = {
      page: params.page,
      page_size: params.page_size,
      sort_type: this.searchInfo.sort_type,
      sort_field: this.searchInfo.sort_field,
    };
    if (this.searchInfo.name) {
      option.name = this.searchInfo.name;
    }
    if (
      this.searchInfo.payment_date &&
      this.searchInfo.payment_date.length > 0
    ) {
      option.payment_date = this.searchInfo.payment_date[0];
      option.payment_date_end = this.searchInfo.payment_date[1];
    }
    if (this.searchInfo.status >= 0) {
      option.status = this.searchInfo.status;
    }
    if (this.searchInfo.task_status.length > 0) {
      option.task_status_arr = this.searchInfo.task_status;
    }
    if (this.searchInfo.month_date && this.searchInfo.month_date.length > 0) {
      option.belong_month_start_date = this.searchInfo.month_date[0];
      option.belong_month_end_date = this.searchInfo.month_date[1];
    }
    getSalaryOrderListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((item: any) => {
          item.create_time = dateFormat(
            "YYYY-mm-dd HH:MM",
            item.create_time * 1000
          );
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.page = params.page;
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleSortChange(e: { order: string; prop: string }) {
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.searchInfo.sort_field = e.prop;
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  toDetail(row: any) {
    this.mixinSavePageInfo("salaryTabStore");
    this.$router.push({
      name: "settlementDetail",
      query: {
        id: String(row.salary_id),
      },
    });
  }
  toStaffSalary() {
    this.$router.push({
      name: "staffSalary",
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
